import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import useStores from '../../hooks/useStores';
import { Filter, Loading, Message } from '../../components';
import { DraftListItem } from './components';
import { Box } from '@material-ui/core';
import { IExchange } from '../../domain/Exchange';
import moment from 'moment';
import _ from 'lodash';

const Draft = () => {
  const { exchangeHistoryStore, userStore } = useStores();
  const [data, setData] = useState<IExchange[]>();

  useEffect(() => {
    userStore.badges();
    exchangeHistoryStore.loadDraftExchanges();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (exchangeHistoryStore.loaded && exchangeHistoryStore.drafts) {
      setData(exchangeHistoryStore.drafts);
    }
  }, [exchangeHistoryStore.loaded, exchangeHistoryStore.drafts]);

  if (!exchangeHistoryStore.loaded) {
    return <Loading />;
  }

  if (exchangeHistoryStore.drafts?.length === 0) {
    return <Message logo="folder" title="drafts.empty" subtitle="drafts.hint" />;
  }

  const onFilterChange = (filter: any) => {
    if (!filter) {
      setData(exchangeHistoryStore.drafts);
      return;
    }

    let result = exchangeHistoryStore.drafts!;
    if (filter.notary?.value) {
      const filterValue = filter.notary.value.toLowerCase();
      const predicate = (x: IExchange) => x.recipients.find((n) => n.notary.name?.toLowerCase().includes(filterValue));

      result = _.filter(result, predicate) as IExchange[];
    }

    if (filter.status) {
      result = _.filter(result, (x) => x.status === filter.status.value);
    }

    if (filter.period) {
      const from = moment(filter.period.value.from).subtract(1, 'days');
      const to = moment(filter.period.value.to).add(1, 'days');
      result = _.filter(result, (x) => moment(x.updatedAt).isBetween(from, to, 'day'));
    }

    setData(result);
  };

  return (
    <Box>
      <Filter filterType="exchange" onFilterChange={onFilterChange} />
      {data?.map((item) => (
        <DraftListItem key={item.id} exchange={item} />
      ))}
    </Box>
  );
};

export default observer(Draft);
